module.exports = __webpack_public_path__ + "img/orders.4cc5e594.svg";